window.addEventListener('DOMContentLoaded', () => {
	const map = document.querySelector('section.locations .map')
	const locationItems = document.querySelectorAll('section.locations .location-item')
	locationItems.forEach(item => {
		item.addEventListener('mouseover', e => {
			const location = item.dataset.location
			map.querySelector(`.${location}`).classList.add('active')
		})
		item.addEventListener('mouseout', e => {
			const location = item.dataset.location
			map.querySelector(`.${location}`).classList.remove('active')
		})
	})
})
